import GroupIndex from '@/views/core/groups/Index'
import GroupDetail from '@/views/core/groups/Detail'
import GroupForm from '@/views/core/groups/Form'
import Permissions from '@/views/core/groups/permissions/Permissions'
import Users from '@/views/core/groups/users/Users'

import ModulesIndex from '@/views/core/modules/Index'

export default
[
    {
        name:'core:index',
        path:'/core',
        component: {
            template: '<div><router-view /></div>'
        },
        children: [
            {
                name:`groups:index`,
                path:`groups`,
                component: GroupIndex
            },
            {
                name:`groups:create`,
                path: `groups/create`,
                component: GroupForm
            },
            {
                name:`groups:update`,
                path: `groups/:groupId/update`,
                component: GroupForm
            },
            {
                name: `groups:detail`,
                path: `groups/:groupId`,
                component: GroupDetail,
                props:true,
                children: [
                    {
                        name: `groups:detail:permissions`,
                        path: 'permissions',
                        component:  Permissions,
                        props:true
                    },
                    {
                        name: `groups:detail:users`,
                        path: 'users',
                        component:  Users,
                        props:true
                    }
                ]
            },



            {
                name:`modules:index`,
                path:`modules`,
                component: ModulesIndex
            }              
        ]
    }
]